import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  comboPack: [],
};

export const comboPackSlice = createSlice({
  name: "comboPack",
  initialState,
  reducers: {
    // ✅ Add all combo packs (e.g., from API)
    addAllComboPacks: (state, action) => {

      // console.log(action.payload);
      state.comboPack = action.payload;
    },

    // ✅ Add a single combo pack
    addComboPack: (state, action) => {
      state.comboPack.push(action.payload);
    },

    // ✅ Update combo pack
    updateComboPack: (state, action) => {
      const updatedCombo = action.payload;
      const index = state.comboPack.findIndex(
        (combo) => combo._id === updatedCombo._id
      );
      if (index !== -1) {
        state.comboPack[index] = {
          ...state.comboPack[index],
          ...updatedCombo,
        };
      }
    },

    // ✅ Delete combo pack
    deleteComboPack: (state, action) => {
      const id = action.payload;
      state.comboPack = state.comboPack.filter(
        (combo) => combo._id !== id
      );
    },
  },
});

export const {
  addAllComboPacks,
  addComboPack,
  updateComboPack,
  deleteComboPack,
} = comboPackSlice.actions;

export default comboPackSlice.reducer;
